"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmergencyItem = void 0;
const ui_1 = require("@app/component/ui");
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const use_debounce_1 = require("@app/util/forms/use-debounce");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const shift_context_1 = require("../shift-context");
const EmergencyItem = ({ index, field, update, error, }) => {
    const { formControl, disabledEditation } = (0, shift_context_1.useShift)();
    const period = (0, react_hook_form_1.useWatch)({ control: formControl, name: 'period' });
    const emergencyNoteOnChange = react_1.default.useCallback((newNote) => update(index, {
        note: newNote,
        start: field.start,
        duration: field.duration,
    }), [update, index, field.start, field.duration]);
    const { value: emergencyNoteValueDebounced, onChange: emergencyNoteOnChangeDebounced, } = (0, use_debounce_1.useDebounce)({
        value: (0, maybe_unwrap_1.unwrapMaybe)(field.note),
        onChange: emergencyNoteOnChange,
        ms: 1000,
    });
    const emergencyStartOnChange = react_1.default.useCallback((newStart) => update(index, {
        start: newStart,
        duration: field.duration,
        note: field.note,
    }), [update, index, field.duration, field.note]);
    const { value: emergencyStartValueDebounced, onChange: emergencyStartOnChangeDebounced, } = (0, use_debounce_1.useDebounce)({
        value: field.start ?? 0,
        onChange: emergencyStartOnChange,
        ms: 750,
    });
    const emergencyDurationOnChange = react_1.default.useCallback((newDuration) => update(index, {
        start: field.start,
        duration: newDuration,
        note: field.note,
    }), [update, index, field.start, field.note]);
    const { value: emergencyDurationValueDebounced, onChange: emergencyDurationOnChangeDebounced, } = (0, use_debounce_1.useDebounce)({
        value: field.duration ?? 0,
        onChange: emergencyDurationOnChange,
        ms: 750,
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ui_1.Input, { type: 'time', label: (0, util_1.t)('ACTIVITY_START'), size: 'full-width', disabled: (0, util_1.isDefined)(disabledEditation), value: (0, moment_1.default)(period.start)
                .add(emergencyStartValueDebounced, 'minutes')
                .format('HH:mm'), onChange: (val) => {
                let startMoment = (0, moment_1.default)(`${(0, moment_1.default)(period.start).format('YYYY-MM-DD')} ${val}`, 'YYYY-MM-DD HH:mm');
                if (startMoment.startOf('minute').isBefore(period.start.startOf('minute')))
                    startMoment = startMoment.clone().add(1, 'day');
                const newStart = startMoment
                    .startOf('minute')
                    .diff(period.start.startOf('minute'), 'minutes');
                emergencyStartOnChangeDebounced(newStart);
            }, ...error }),
        react_1.default.createElement(ui_1.Input, { type: 'time', label: (0, util_1.t)('ACTIVITY_END'), size: 'full-width', disabled: (0, util_1.isDefined)(disabledEditation), value: (0, moment_1.default)(period.start)
                .add(emergencyStartValueDebounced + emergencyDurationValueDebounced, 'minutes')
                .format('HH:mm'), onChange: (val) => {
                const endMoment = (0, moment_1.default)(`${(0, moment_1.default)(period.start).format('YYYY-MM-DD')} ${val}`, 'YYYY-MM-DD HH:mm');
                let newDuration = endMoment
                    .startOf('minute')
                    .diff(period.start.startOf('minute'), 'minutes') -
                    emergencyStartValueDebounced;
                if (newDuration <= 0)
                    newDuration += 1440;
                if (newDuration > 1440)
                    newDuration -= 1440;
                emergencyDurationOnChangeDebounced(newDuration);
            } }),
        react_1.default.createElement(ui_1.Input, { type: 'text', size: 'full-width', label: (0, util_1.t)('NOTE'), disabled: (0, util_1.isDefined)(disabledEditation), value: emergencyNoteValueDebounced, onChange: emergencyNoteOnChangeDebounced })));
};
exports.EmergencyItem = EmergencyItem;
